import { render, staticRenderFns } from "./CharacterForm.vue?vue&type=template&id=caea5b42&scoped=true&"
import script from "./CharacterForm.vue?vue&type=script&lang=js&"
export * from "./CharacterForm.vue?vue&type=script&lang=js&"
import style0 from "./CharacterForm.vue?vue&type=style&index=0&id=caea5b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caea5b42",
  null
  
)

export default component.exports